import { css } from '@emotion/react';

const getTableBodyLoadingCss = css`
  pointer-events: none;
  opacity: 0.16;
`;

export default getTableBodyLoadingCss;
